// export default {
//   data() {
//     return {
//       lastTime: null, // 最后一次点击的时间
//       currentTime: null, // 当前点击的时间
//       timeOut: 1000, // 设置超时时间：20分钟
//     }
//   },
//   methods: {
//     isDo() {
//       console.log('isDo')
//       this.currentTime = new Date().getTime() //记录这次点击的时间
//       console.log(this.currentTime)
//       if (this.currentTime - this.lastTime > this.timeOut) { //判断上次最后一次点击的时间和这次点击的时间间隔是否大于10分钟
//         // 这里写状态已过期后执行的操作
//         this.$message.warning('長時間未操作！請重新登錄')
//         this.$router.push('login')
//       } else {
//         this.lastTime = new Date().getTime() //如果在10分钟内点击，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
//       }
//     }
//   },
//   created(){
//     this.lastTime = new Date().getTime() //网页第一次打开时，记录当前时间
//     console.log(this.lastTime)
//   }
// }



// 如何使用
// 
// /App.vue
// 
// import { isOperateFun } from '@/utils/timingLock.js'
// 
// created() {
//   isOperateFun()
// }

// 用户长时间未操作 退出登录
import store from '@/store'
import router from '@/router'
var timer = null

clearInterval(timer)

export function stopOperateFun() {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
}

export function isOperateFun(seconds) {
  if (timer) {
    clearInterval(timer)
    timer = null
  }

  var lastTime = new Date().getTime() // 最后一次点击时间
  var currentTime = new Date().getTime() // 当前时间
  var timeOut = (seconds || 30) * 1000 // 允许最长未操作时间
  var i = 1 // 辅助作用

  function handleReset() { // 重新赋值最后一次点击时间，清除定时器，重新开始定时器
    // console.log('又点击了！！！！！！')
    i = 1

    lastTime = new Date().getTime()

    if (timer) {
      clearInterval(timer)
      timer = null
    }

    if (!timer) {
      // console.log('真好！重新开始')
      handleInterval()
    }
  }

  function handleInterval() { // 定时器
    timer = setInterval(() => {
      currentTime = new Date().getTime() // 当前时间

      // console.log(`${i++}-currentTime`, currentTime)
      // console.log('最后一次点击时间', lastTime)

      if (currentTime - lastTime > timeOut) {
        console.log('—————————————————— 长时间未操作 ——————————————————')

        clearInterval(timer) // 清除定时器

        // // 执行退出并跳转到首页
        // store.dispatch('user/logout').then(() => {
          const PATH = window.location.href.split('#')[1].replace(/\?[^?]+/,'')

          // 判断当前路由不是登錄页 则跳转至登錄页
          console.log(1111, PATH, store.state.scan_canLeave_x)
          if (['/login', '/lock', '/clock'].includes(PATH)) {
            isOperateFun(seconds)
          } else if (!store.state.scan_canLeave_x) {
            isOperateFun(seconds)
          } else if (store.state.el_loading_x) {
            isOperateFun(seconds)
          } else {
            router.push('/lock')
          }

        //   // 执行安卓退出方法
        //   window.AndroidWebView.loginOut()
        // })
      }
    }, 1000)
  }

  handleInterval() // 一开始程序 默认执行定制器



  document.onclick = () => { // 单击事件
    handleReset()
  }
  document.ondblclick = () => { // 双击事件
    handleReset()
  }
  document.onmousedown = () => { // 按下鼠标键时触发
    handleReset()
  }
  document.onmouseup = () => { // 释放按下的鼠标键时触发
    handleReset()
  }
  document.onmousemove = () => { // 鼠标移动事件
    handleReset()
  }
  document.onmouseover = () => { // 移入事件
    handleReset()
  }
  document.onmouseout = () => { // 移出事件
    handleReset()
  }
  document.onmouseenter = () => { // 移入事件
    handleReset()
  }
  document.onmouseleave = () => { // 移出事件
    handleReset()
  }
  document.ontouchstart = () => { // 移動端滑動事件
    handleReset()
  }
  document.ontouchmove = () => { // 移動端滑動事件
    handleReset()
  }
  document.ontouchend = () => { // 移動端滑動事件
    handleReset()
  }
}